export default __webpack_public_path__ + "static/media/logo1w.02aca1da.svg";